import Vue from 'vue';
import Router from 'vue-router';
// import store from '@/store/store.js';

/* 初始路由 */
let router = new Router({
  // mode: 'history',
  routes: [

    {
      path: "/",
      redirect: 'login',
      component: () => import("../components/login")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../components/login")
    },

    {
      path: '/home',
      name: 'home',
      component: () => import('../components/home'),
      redirect: '/product/management',
      meta: {
        requiresAuth: true,
        permitName: '首页'
      },
      children: [{
          path: '/dash-boards',
          name: 'dash-boards',
          component: () => import('@/components/dash-board'),
          meta: {
            permitName: '票务管理系统'
          }
        },
        // 工作台-待办事项

        {
          path: '/user/list',
          name: 'userView',
          component: () => import('../components/sys/userView'),
          meta: ["系统管理", "用户管理"]
        },
        {
          path: '/role/list',
          name: 'roleView',
          component: () => import('../components/sys/roleView'),
          meta: ["系统管理", "角色管理"]
        },
        {
          path: '/permission/list',
          name: 'gongNeng',
          component: () => import('../components/sys/gongneng.vue'),
          meta: ["系统管理", "功能管理"]
        },
        {
          path: '/Department/management',
          name: 'management',
          component: () => import('../components/sys/management.vue'),
          meta: ["系统管理", "部门管理"]
        },
        {
          path: '/management/log',
          name: 'logmeg',
          component: () => import('../components/sys/logmeg.vue'),
          meta: ["系统管理", "日志管理"]
        },
        {
          path: '/druid/monitor',
          name: 'monitor',
          component: () => import('../components/sys/monitor.vue'),
          meta: ["系统管理", "系统监控"]
        },
        {
          path: '/dictionary/type',
          name: 'dictionaryType',
          component: () => import('../components/sys/dicDataView'),
          meta: ["字典管理", "字典类型管理"]
        },

        {
          path: '/dictionary/data',
          name: 'dictionaryData',
          component: () => import('../components/sys/dictionaryData.vue'),
          meta: ["字典管理", "字典数据管理"]
        },
        // 票务
        {
          path: '/ticket/allocation',
          name: 'allocation',
          component: () => import('../components/ticket/ticket-allo.vue'),
          meta: ["票务管理", "票务配置"]
        },
        {
          path: '/ticket/period',
          name: 'period',
          component: () => import('../components/ticket/period.vue'),
          meta: ["票务管理", "时段配置"]
        },
        {
          path: '/configuration/employeecard',
          name: 'employeecard',
          component: () => import('../components/ticket/employeecard.vue'),
          meta: ["票务管理", "员工卡配置"]
        },
        {
          path: '/ticket/addcation',
          name: 'addcation',
          component: () => import('../components/ticket/ticket-add.vue'),
          meta: ["票务管理", "票务新增配置"]
        },
        {
          path: '/ticket/timecation',
          name: 'timecation',
          component: () => import('../components/ticket/ticket-time.vue'),
          meta: ["票务管理", "票务时段配置"]
        },
        {
          path: '/ticket/appiot_list',
          name: 'appiot_list',
          component: () => import('../components/ticket/appointment-list.vue'),
          meta: ["票务管理", "参观人列表"]
        },
        {
          path: '/ticket/appiot_detail',
          name: 'appiot_detail',
          component: () => import('../components/ticket/order_detail.vue'),
          meta: ["票务管理", "参观人详情"]
        },
        {
          path: '/ticket/riskArea',
          name: 'riskArea',
          component: () => import('../components/ticket/riskArea.vue'),
          meta: ["票务管理", "风险地配置"]
        },
        {
          path: '/ticket/riskadd',
          name: 'riskadd',
          component: () => import('../components/ticket/riskadd.vue'),
          meta: ["票务管理", "风险地配置新增"]
        },
        // 统计分析
        {
          path: '/ticket/visiterday',
          name: 'visiterday',
          component: () => import('../components/monopolizing/visiterday.vue'),
          meta: ["统计分析", "预约人数"]
        },
        {
          path: '/ticket/Checknum',
          name: 'Checknum',
          component: () => import('../components/monopolizing/Checknum.vue'),
          meta: ["统计分析", "检票人数"]
        },
        {
          path: '/ticket/age_group',
          name: 'age_group',
          component: () => import('../components/monopolizing/age-group.vue'),
          meta: ["统计分析", "参观年龄段"]
        },
        {
          path: '/ticket/Checknum',
          name: 'Checknum',
          component: () => import('../components/monopolizing/Checknum.vue'),
          meta: ["统计分析", "检票人数"]
        },
        {
          path: '/ticket/menAndwo',
          name: 'menAndwo',
          component: () => import('../components/monopolizing/menAndwo.vue'),
          meta: ["统计分析", "参观人性别"]
        },
        {
          path: '/ticket/province',
          name: 'province',
          component: () => import('../components/monopolizing/ticket-pre.vue'),
          meta: ["统计分析", "参观人省份"]
        },
        {
          path: '/data/report',
          name: 'reportData',
          component: () => import('../components/monopolizing/reportData.vue'),
          meta: ["统计分析", "数据上报"]
        },
        {
          path: '/statistics/ticketType',
          name: 'ticketType',
          component: () => import('../components/monopolizing/ticketType.vue'),
          meta: ["统计分析", "票种统计"]
        },
        {
          path: '/identification',
          name: 'identification',
          component: () => import('../components/certificate/certIdentificat.vue'),
          meta: ["测试", "测试"]
        },
        {
          path: '/ticket/documenttype',
          name: 'documenttype',
          component: () => import('../components/monopolizing/documenttype.vue'),
          meta: ["统计分析", "证件类型"]
        },

        {
          path: '/ticket/visit_time',
          name: 'visit_time',
          component: () => import('../components/monopolizing/visit_time.vue'),
          meta: ["统计分析", "参观时间"]
        },
        // 产品管理
        {
          path: '/product/management',
          name: 'productmanag',
          component: () => import('../components/product/productmanag.vue'),
          meta: ["产品管理", "产品配置"]
        },
        {
          path: '/product/configure',
          name: 'configure',
          component: () => import('../components/product/configure.vue'),
          meta: ["产品管理", "产品配置"]
        },
        {
          path: '/ticket/record',
          name: 'record',
          component: () => import('../components/product/record.vue'),
          meta: ["产品管理", "售票记录"]
        },
        {
          path: '/ticket/orderdetail',
          name: 'orderdetail',
          component: () => import('../components/product/orderdetail.vue'),
          meta: ["产品管理", "订单详情"]
        },
        {
          path: '/appointment/instructions',
          name: 'instructions',
          component: () => import('../components/product/instructions.vue'),
          meta: ["产品管理", "预约须知"]
        },
        // 游客信息Tourist information
        {
          path: '/ticket/touristInformat',
          name: 'touristInformat',
          component: () => import('../components/product/touristInformat.vue'),
          meta: ["产品管理", "游客信息"]
        },
        {
          path: '/import/bulk',
          name: 'bulk',
          component: () => import('../components/product/bulk.vue'),
          meta: ["统计分析", "团队管理"]
        },
        {
          path: '/ticket/bulkdetail',
          name: 'bulkdetail',
          component: () => import('../components/product/bulkDetail.vue'),
          meta: ["统计分析", "订单详情"]
        },
        {
          path: '/ticket/teamOnline',
          name: 'teamOnline',
          component: () => import('../components/ticket/teamOnline.vue'),
          meta: ["统计分析", "团队线上预约管理"]
        },
        {
          path: '/ticket/teamOnlinedetail',
          name: 'teamOnlinedetail',
          component: () => import('../components/ticket/teamOnlinedetail.vue'),
          meta: ["统计分析", "团队线上预约管理"]
        },
        {
          path: '/ticket/teamTournum',
          name: 'teamTournum',
          component: () => import('../components/ticket/teamTournum.vue'),
          meta: ["统计分析", "地区分析"]
        },
        {
          path: '/ticket/foreign',
          name: 'foreign',
          component: () => import('../components/ticket/foreign.vue'),
          meta: ["统计分析", "外籍统计"]
        },
        // {
        //     path: '/ticket/orderdetail',
        //     name: 'orderdetail',
        //     component: () => import('../components/product/orderdetail.vue'),
        //     meta:["产品管理", "订单详情"]
        // },
      ]
    },
  ]
});







// 挂载路由导航守卫


router.beforeEach((to, from, next) => {
  // to：将要访问的路径
  // from：代表从那个路径跳转而来
  // next是一个函数,表示放行;  next() 放行    next('/login') 强制跳转

  // 如果用户访问的登录页，直接放行
  if (to.path === '/login') return next()
  // // 从sessionStorage中获取到保存的token值
  const tokenStr = window.sessionStorage.getItem('token');
  // console.log(tokenStr)
  // 没有token 强制跳转到登录页
  if (!tokenStr) return next('/login')
  next()
})


Vue.use(Router);

export default router;

/* 准备动态添加的路由 */
export const dynamicRoutes = [
  // {
  //     path: '/',
  //     name: 'home',
  //     component: () => import('../components/home'),
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [

  //     ]
  // },
  // {
  //     path: '/403',
  //     component: () => import('../components/403')
  // },
  // {
  //     path: '*',
  //     component: () => import('../components/403')
  // }
];
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)

}



// WEBPACK FOOTER //
// ./src/router/index.js